export const getLocalStorageKey = (key: string) => `@${key}/isShowTotals`;
